import React, { useEffect, useRef } from 'react';
import { Formik, Field } from 'formik';
import { InputField } from '../../../../../components/formFields/InputField';
import { SelectFormField } from '../../../../../components/formFields/SelectFormField';
import * as Yup from 'yup';
import { getFieldErrors } from '../../../../../utils/apiError';

type UnitsFormProps = {
  formProps?: any;
  submitOutside?: boolean;
  submit: (values: any) => void;
  error?: any;
  reset?: boolean;
  cultures?: any[];
  resetConfirm?: () => void;
  isActiveForm?: boolean;
  isEditCultureMutations?: boolean;
};

const UnitsForm = ({
  formProps = {},
  submitOutside,
  submit,
  error,
  reset,
  cultures,
  resetConfirm,
  isActiveForm,
  isEditCultureMutations = false,
}: UnitsFormProps) => {
  const formRef = useRef<any>();

  useEffect(() => {
    let isSubscribed = true;

    if (isSubscribed && submitOutside) {
      formRef.current.submitForm();
    }

    return () => {
      isSubscribed = false;
    };
  }, [submitOutside]);

  useEffect(() => {
    if (reset === true) {
      formRef.current.setValues(formProps);
      resetConfirm?.();
    }
  }, [reset]);

  useEffect(() => {
    formRef.current.setErrors(getFieldErrors(error));
  }, [error]);

  const init = (props: any) => {
    if (props) {
      return {
        title: props.title,
        mark: props.mark,
        description: props.description,
        is_active: props.is_active ? 1 : 2,
      };
    }
    return {
      title: null,
      biblio: null,
      mark: null,
      description: null,
      is_active: null,
    };
  };

  const ValidationSchema = Yup.object().shape({
    title: Yup.string().nullable().required('Povinné pole'),
    mark: Yup.string().nullable().required('Povinné pole'),
    description: Yup.string().nullable().required('Povinné pole'),
  });

  return (
    <div>
      <Formik
        innerRef={formRef}
        enableReinitialize={true}
        validationSchema={ValidationSchema}
        initialValues={init(formProps)}
        onSubmit={(values) => {
          values.is_active = values.is_active ? 1 : 2;
          submit(values);
        }}
      >
        {(props) => {
          const { values } = props;
          const fields = (
            <>
              {isEditCultureMutations === false && !isActiveForm && (
                <SelectFormField
                  name="biblio"
                  placeholder="Biblio"
                  data={[]}
                  data-testid="units-form-biblio-select"
                />
              )}
              {!isActiveForm && (
                <>
                  <Field
                    name="title"
                    value={values.title || null}
                    placeholder="Název"
                    component={InputField}
                    data-testid="units-form-title-input"
                  />
                  <Field
                    name="mark"
                    value={values.mark || null}
                    placeholder="Značka"
                    component={InputField}
                    data-testid="units-form-mark-input"
                  />
                  <Field
                    name="description"
                    value={values.description || null}
                    placeholder="Popisek"
                    component={InputField}
                    data-testid="units-form-description-input"
                  />
                </>
              )}
              {isEditCultureMutations === false && !isActiveForm && (
                <SelectFormField
                  name="culture"
                  placeholder="Kultura"
                  data={cultures || []}
                  data-testid="units-form-culture-select"
                />
              )}
              {isEditCultureMutations === false && isActiveForm === true && (
                <SelectFormField
                  name="is_active"
                  placeholder=""
                  data={[
                    { value: 1, id: 1, title: 'Aktivní' },
                    { value: 2, id: 2, title: 'Neaktivní' },
                  ]}
                  data-testid="units-form-active-select"
                />
              )}
            </>
          );

          return <div className="space-y-1">{fields}</div>;
        }}
      </Formik>
    </div>
  );
};

export default UnitsForm;
